import RootContainer from "./components/RootContainer";

function App() {
  return <RootContainer />;
}

export default App;
